import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/RefModules/_metronic/core';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';

@Component({
    selector: 'app-comman-header',
    templateUrl: './comman-header.component.html',
    styleUrls: ['./comman-header.component.scss'],
    standalone: false,
})
export class CommanHeaderComponent implements OnInit {
    rootArrowEnabled = false;
    ulCSSClasses: string;
    headerMenuSelfDisplay: string;
    IA = LogoNames.IA;

    constructor(
        private layout: LayoutService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
        this.rootArrowEnabled = this.layout.getProp('header.menu.self.rootArrow');
        this.headerMenuSelfDisplay = this.layout.getProp('header.menu.self.display');
        this.globalEmittersService.isLanguageSetUp.next(true);
    }
}
